module.exports = __webpack_public_path__ + "mobile-format-1.webm";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-start/assets/mobile-format-1.webm
// module id = 1169
// module chunks = 10